import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  icon: {
    fontSize: theme.size.base,
    color: theme.palette.primary.main
  },

  children: {
    width: 'inherit',
    cursor: ({ disabled }) => (disabled ? 'default' : 'pointer')
  },

  day: {
    width: 36,
    height: 36,
    fontSize: 'inherit',
    margin: '0 2px',
    color: '#323436'
  },

  selected: {
    color: 'white',
    backgroundColor: theme.palette.primary.main,

    '&:hover': {
      backgroundColor: `${theme.palette.primary.main} !important`
    }
  },

  faded: {
    color: '#323436',
    opacity: '0.2'
  },

  calendar: {
    '& .MuiPickersYear-root': {
      fontSize: theme.size.sm
    }
  }
}))

export default useStyles
